export default __webpack_public_path__ + "static/srinon-logo-a32fcbe5a3e731c1a65ce2ee4b0591d2.png";